<form (submit)="$event.preventDefault()">
    <h3 id="jobs"><span class="icon-toolbox-solid icon-left"></span>Ingestion Jobs ({{ jobModels.length }})</h3>
    <ng-container *ngFor="let job of jobModels; let jobNumber = index">
        <hc-accordion
            triggerAlign="right"
            #accordion
            class="cdp-accordion"
            [formGroup]="job.form"
            [class.unsaved-job-accordion]="!job.data.tenantIngestionId || job.hasUnsavedChanges"
            [class.invalid-job-accordion]="job.form.invalid"
            [open]="!job.data.tenantIngestionId"
        >
            <!-- Ingestions toolbar -->
            <hc-accordion-toolbar>
                <div class="toolbar">
                    <div class="toolbar-left">
                        <h4>
                            <span>Job #{{ jobNumber + 1 }}</span>
                            <span
                                *ngIf="!job.data.tenantIngestionId || job.hasUnsavedChanges"
                                class="unsaved-job-indicator"
                                >*</span
                            >
                        </h4>
                        <cdp-job-chip
                            [jobId]="job.form.value.ingestionId"
                            [isActive]="job.form.value.activeFlag"
                            [mode]="job.form.value.rawMode"
                        >
                        </cdp-job-chip>
                        <div
                            class="priority-indicator"
                            title="High priority"
                            [class.priority-indicator-inactive]="!isHighPriority(job.form)"
                        >
                            <span>HP</span>
                        </div>
                        <span
                            title="{{ job.schedule && !job.schedule.activeFlag ? 'Schedule is inactive' : '' }}"
                            class="job-sched hc-text-ellipsis job-toolbar-detail"
                            [class.inactive-sched]="job.schedule && !job.schedule.activeFlag"
                        >
                            <span
                                *ngIf="job.schedule && !job.schedule.activeFlag"
                                class="icon-left icon-status-cancelled"
                            ></span
                            >{{ getScheduleDescription(job) }}
                        </span>
                    </div>
                    <div class="toolbar-right">
                        @if (canSaveOwnJobs && hasSourcesEditPermission) {
                            <span
                                *ngIf="!job.data.tenantIngestionId || (job.hasUnsavedChanges && !job.isSaving)"
                                class="job-toolbar-detail job-save-detail cdp-fade-in"
                                [title]="
                                    !job.data.tenantIngestionId
                                        ? 'This new job has not been saved'
                                        : 'This job has unsaved changes'
                                "
                                >*Unsaved {{ !job.data.tenantIngestionId ? 'job' : 'changes' }}
                            </span>
                            <span *ngIf="job.isSaving" class="job-toolbar-detail job-save-detail cdp-fade-in"
                                >Saving...
                            </span>
                        }
                        @if (hasSourcesEditPermission) {
                            <button
                                [hcPop]="jobMenu"
                                title="Job actions..."
                                class="hc-elip-menu hc-action-ico"
                                (click)="$event.stopPropagation()"
                            ></button>
                        }
                        <div
                            class="active-container"
                            [class.readonly]="!hasSourcesEditPermission"
                            (click)="$event.stopPropagation(); $event.preventDefault()"
                        >
                            <hc-slide-toggle
                                title="{{ job.instantActiveFlag.value ? 'Deactivate' : 'Activate' }} this job"
                                (click)="toggleActiveAndInstantSave(job, $event)"
                                [buttonState]="job.instantActiveFlag.value"
                                [insideLabel]="'none'"
                                [disabled]="job.instantActiveFlag.disabled || !hasSourcesEditPermission"
                            ></hc-slide-toggle>
                            <cdp-active-status-display
                                [isActive]="job.form.value.activeFlag"
                            ></cdp-active-status-display>
                        </div>
                    </div>
                </div>
            </hc-accordion-toolbar>

            <!-- toolbar menu-->
            <hc-pop
                #jobMenu
                [autoCloseOnContentClick]="true"
                [showArrow]="false"
                horizontalAlign="before"
                verticalAlign="below"
            >
                <div hcMenu>
                    <button
                        hcMenuItem
                        (click)="queueJob(job)"
                        [disabled]="!job.data.activeFlag || job.hasUnsavedChanges"
                        [title]="
                            job.data.activeFlag && !job.hasUnsavedChanges ? 'Queue job' : 'Job must be active and saved'
                        "
                    >
                        <hc-icon hcMenuIcon fontSet="icon" fontIcon="icon-run"></hc-icon>
                        <span hcMenuText>Queue job</span>
                    </button>
                    <span hcMenuItem hcDivider></span>
                    <button hcMenuItem (click)="deleteIngestion(job)">
                        <hc-icon hcMenuIcon fontSet="icon" fontIcon="icon-trash"></hc-icon>
                        <span hcMenuText>Delete job</span>
                    </button>
                </div>
            </hc-pop>

            <!-- Ingestion form-->
            <h4><span class="icon-left icon-cog"></span>Configuration</h4>

            <div
                *ngIf="job.form.controls['rawMode'].errors?.otherActiveJobsWithSameMode === true"
                class="other-active-jobs-with-mode-error error-section"
            >
                <span class="icon-warn error-section-ico"></span>
                <span>An entity cannot have multiple active jobs with the same mode</span>
            </div>

            <div class="cdp-row">
                <div class="cdp-form-field cdp-form-field-mode col-custom ingest-form-col">
                    <label for="rawMode"
                        >Mode<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.modeHelp"
                        ></span
                    ></label>
                    <ng-select
                        formControlName="rawMode"
                        [items]="getRawModeOptionsForJob(job)"
                        bindValue="name"
                        [clearable]="false"
                        bindLabel="name"
                        placeholder="Select ingestion mode..."
                        [searchable]="false"
                        labelForId="rawMode"
                        [required]="true"
                        appendTo="body"
                    >
                        <ng-template ng-option-tmp let-item="item">
                            <div class="raw-mode-option" [title]="item.disabled ? refKeysRequiredMessage : ''">
                                <cdp-job-chip
                                    [mode]="item.name"
                                    [jobId]="job.form.value.ingestionId"
                                    [isActive]="job.form.value.activeFlag"
                                >
                                </cdp-job-chip>
                                <span>
                                    <span class="raw-mode-name">{{ item.name }}</span>
                                    <span class="raw-mode-help">{{ item.help }}</span>
                                </span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="cdp-row ingest-form-row" *ngIf="isFull(job.form) && isFileSourceType">
                <hc-form-field class="col-custom" [class.cdp-field-warning]="isWatermarkChange(job)">
                    <hc-label
                        >Watermark Value<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.watermarkValueHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="rawWatermarkValue" />
                    <span
                        hcSuffix
                        *ngIf="isWatermarkValueChange"
                        class="icon-warn"
                        [hcTooltip]="tooltips.watermarkChangeWarning"
                    ></span>
                </hc-form-field>
            </div>

            <div
                class="cdp-row ingest-form-row"
                *ngIf="isBackFill(job.form) || isIncremental(job.form) || isCsaOrCdcMode(job.form)"
            >
                <hc-form-field
                    class="col-custom"
                    [ngClass]="{
                        'batch-size-input-details-page': isBackFill(job.form) && canSaveOwnJobs,
                        'batch-size-input-edit-modal': isBackFill(job.form) && !canSaveOwnJobs
                    }"
                    [class.cdp-field-warning]="smallBatchSizeWarning(job.form)"
                >
                    <hc-label
                        >Batch Size<span cdpRequiredMarker></span
                        ><span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcPop]="batchSizeHelp"
                            trigger="hover"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="rawBatchSize" />
                    <span
                        hcSuffix
                        *ngIf="smallBatchSizeWarning(job.form)"
                        class="icon-warn"
                        [hcTooltip]="tooltips.smallBatchSizeWarning"
                    ></span>
                    <hc-error> {{ batchSizeErrorMessage(job.form) }} </hc-error>
                    <hc-pop #batchSizeHelp [disableStyle]="true" verticalAlign="above">
                        <div class="hc-tooltip">
                            Controls the unit of work processed per execution, with behavior dependent on the load type.
                            <ul class="batch-size-help">
                                <li>
                                    <strong>Incremental loads:</strong> represents the
                                    <strong>maximum number of records</strong> processed per batch.
                                </li>
                                <li>
                                    <strong>Backfill loads:</strong> represents the
                                    <strong> number of hours to look back</strong> when evaluating the watermark.
                                </li>
                            </ul>
                        </div>
                    </hc-pop>
                </hc-form-field>
                <div
                    [ngClass]="{
                        'watermark-key-container-standard': !isBackFill(job.form),
                        'watermark-key-container-backfill': isBackFill(job.form)
                    }"
                >
                    <hc-form-field class="col-custom" [ngClass]="{ 'watermark-key-input': isBackFill(job.form) }">
                        <hc-label
                            >Watermark Key<span cdpRequiredMarker></span
                            ><span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.watermarkKeyHelp"
                            ></span
                        ></hc-label>
                        <input
                            hcInput
                            maxlength="255"
                            formControlName="rawWatermarkKey"
                            [readonly]="isCsaOrCdcMode(job.form)"
                        />
                        <hc-icon hcSuffix fontSet="icon" fontIcon="icon-search"></hc-icon>
                        <hc-error>
                            Watermark Key is required
                            <span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.watermarkKeyHelp"
                            ></span>
                        </hc-error>
                    </hc-form-field>
                    @if (isBackFill(job.form)) {
                        <div
                            class="watermark-key-datatype-input cdp-form-field cdp-form-field-mode col-custom ingest-form-col"
                        >
                            <label
                                >Watermark Key Datatype<span
                                    class="icon-info cdp-info-ico cdp-info-ico-right"
                                    [hcTooltip]="tooltips.watermarkKeyDatatypeHelp"
                                ></span
                            ></label>
                            <ng-select
                                formControlName="rawWatermarkKeyDatatype"
                                placeholder="Select datatype..."
                                [items]="job.data.rawWatermarkKeyDatatypeOptions"
                                bindValue="value"
                                bindLabel="name"
                                [clearable]="true"
                                [searchable]="false"
                                labelForId="rawWatermarkKeyDatatype"
                            >
                            </ng-select>
                        </div>
                    }
                </div>
                <hc-form-field
                    *ngIf="isIncremental(job.form) || isCsaOrCdcMode(job.form)"
                    class="col-custom"
                    [class.cdp-field-warning]="isWatermarkChange(job)"
                >
                    <hc-label
                        >Watermark Value<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.watermarkValueHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="rawWatermarkValue" />
                    <span
                        hcSuffix
                        *ngIf="isWatermarkValueChange"
                        class="icon-warn"
                        [hcTooltip]="tooltips.watermarkChangeWarning"
                    ></span>
                </hc-form-field>
            </div>
            <!-- CDC Table / CDC Schema fields for Incremental_CDC mode -->
            <div class="cdp-row ingest-form-row" *ngIf="isCDC(job.form)">
                <hc-form-field class="col-custom">
                    <hc-label
                        >CDC Table<span cdpRequiredMarker></span
                        ><span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.cdcTableHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="cdcTable" />
                    <hc-error>CDC Table is required</hc-error>
                </hc-form-field>
                <hc-form-field class="col-custom">
                    <hc-label
                        >CDC Schema<span cdpRequiredMarker></span
                        ><span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.cdcSchemaHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="cdcSchema" />
                    <hc-error>CDC Schema is required</hc-error>
                </hc-form-field>
            </div>
            <!-- Watermark fields for Append/Replace modes -->
            <div class="cdp-row ingest-form-row" *ngIf="isAppend(job.form) || isReplace(job.form)">
                <hc-form-field class="col-custom">
                    <hc-label
                        >Watermark Key<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.watermarkKeyHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="rawWatermarkKey" />
                    <hc-icon hcSuffix fontSet="icon" fontIcon="icon-search"></hc-icon>
                </hc-form-field>
                <hc-form-field class="col-custom" [class.cdp-field-warning]="isWatermarkChange(job)">
                    <hc-label
                        >Watermark Value<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.watermarkValueHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="rawWatermarkValue" />
                    <span
                        hcSuffix
                        *ngIf="isWatermarkValueChange"
                        class="icon-warn"
                        [hcTooltip]="tooltips.watermarkChangeWarning"
                    ></span>
                </hc-form-field>
            </div>
            <div class="cdp-row ingest-form-row" *ngIf="isBackFill(job.form)">
                <hc-form-field class="col-custom">
                    <hc-label
                        >Backfill Minimum<span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.backFillMinHelp"
                        ></span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="backFillMinimum" />
                </hc-form-field>
                <hc-form-field class="col-custom" [class.cdp-field-warning]="isWatermarkChange(job)">
                    <hc-label
                        >Watermark Value<span cdpRequiredMarker></span
                        ><span
                            class="icon-info cdp-info-ico cdp-info-ico-right"
                            [hcTooltip]="tooltips.backfillWatermarkHelp"
                        >
                        </span
                    ></hc-label>
                    <input hcInput maxlength="255" formControlName="backFillDate" />
                    <span
                        hcSuffix
                        *ngIf="isWatermarkValueChange"
                        class="icon-warn"
                        [hcTooltip]="tooltips.watermarkChangeWarning"
                    ></span>
                    <hc-error> Watermark value is required </hc-error>
                </hc-form-field>
            </div>

            <div class="cdp-row">
                <span class="toggle-control col-12">
                    <hc-form-field>
                        <hc-slide-toggle
                            formControlName="activeFlag"
                            (click)="$event.stopPropagation()"
                            insideLabel="yes"
                            sideLabel="Active"
                        ></hc-slide-toggle>
                    </hc-form-field>
                    <span class="icon-info cdp-info-ico icon-right" [hcTooltip]="tooltips.activeHelp"></span>
                    <hc-form-field>
                        <hc-slide-toggle
                            class="priority-control"
                            [buttonState]="isHighPriority(job.form)"
                            (buttonStateChanged)="onPriorityToggle($event, job.form)"
                            [insideLabel]="'yes'"
                            sideLabel="High Priority"
                            buttonStyle="red"
                            [disabled]="job.form.disabled || !hasSourcesEditPermission"
                        ></hc-slide-toggle>
                        <span class="icon-info cdp-info-ico icon-right" [hcTooltip]="tooltips.priorityHelp"></span>
                    </hc-form-field>
                </span>
            </div>

            <cdp-schedule-jobs
                [schedules]="schedules"
                [(form)]="job.form.controls.schedule"
                [tenantId]="tenantId"
                [hasSourcesEditPermission]="hasSourcesEditPermission"
            ></cdp-schedule-jobs>

            <hc-accordion class="cdp-tight-accordion">
                <hc-accordion-toolbar
                    ><span class="toolbar-title">Advanced</span><span class="icon-chev-down icon-right"></span
                ></hc-accordion-toolbar>
                <div class="cdp-row ingest-form-row">
                    <hc-form-field class="col-custom">
                        <hc-label
                            >Custom Notebook<span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.customNotebookHelp"
                            ></span
                        ></hc-label>
                        <input
                            hcInput
                            maxlength="255"
                            formControlName="customNotebook"
                            placeholder="path/to/notebook"
                        />
                    </hc-form-field>
                    <hc-form-field
                        *cdpHideIfFeatureFlagOff="featureflags.ShowNewIngestConfigurationFields"
                        class="col-custom"
                    >
                        <hc-label
                            >Custom Extractor Notebook<span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.customExtractorNotebookHelp"
                            >
                            </span
                        ></hc-label>
                        <input
                            hcInput
                            maxlength="255"
                            formControlName="customExtractorNotebook"
                            placeholder="path/to/notebook"
                        />
                    </hc-form-field>
                </div>
                <div class="cdp-row ingest-form-row">
                    <hc-form-field class="col-custom">
                        <hc-label
                            >Custom Cluster<span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.customClusterHelp"
                            >
                            </span
                        ></hc-label>
                        <input hcInput maxlength="255" formControlName="customCluster" placeholder="Enter cluster" />
                    </hc-form-field>
                    <hc-form-field
                        *cdpHideIfFeatureFlagOff="featureflags.ShowNewIngestConfigurationFields"
                        class="col-custom"
                    >
                        <hc-label
                            >DateTime Format<span
                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                [hcTooltip]="tooltips.dateTimeFormatHelp"
                            >
                            </span
                        ></hc-label>
                        <input hcInput maxlength="255" formControlName="dateTimeFormat" placeholder="Enter format..." />
                    </hc-form-field>
                </div>
                <div class="cdp-row ingest-form-row">
                    <span class="toggle-control col-12">
                        <hc-form-field
                            *cdpHideIfFeatureFlagOff="featureflags.ShowNewIngestConfigurationFields"
                            class="col-custom"
                        >
                            <hc-slide-toggle
                                sideLabel="Copy null watermark value"
                                formControlName="copyNullWatermarkValue"
                                insideLabel="yes"
                                (click)="$event.stopPropagation()"
                            >
                            </hc-slide-toggle>
                            <span
                                class="icon-info cdp-info-ico icon-right"
                                [hcTooltip]="tooltips.copyNullWatermarkValueHelp"
                            ></span>
                        </hc-form-field>
                        <hc-form-field class="col-custom">
                            <hc-slide-toggle
                                sideLabel="Use legacy engine"
                                formControlName="useLegacyEngine"
                                insideLabel="yes"
                                required
                                (click)="$event.stopPropagation()"
                            >
                            </hc-slide-toggle>
                            <span
                                class="icon-info cdp-info-ico icon-right"
                                [hcTooltip]="tooltips.useLegacyEngineHelp"
                            ></span>
                        </hc-form-field>
                    </span>
                </div>
            </hc-accordion>
            <hr *ngIf="canSaveOwnJobs" class="footer-border" />
            <div class="col-custom footer" *ngIf="canSaveOwnJobs">
                <cdp-watermark-change-warning-chip *ngIf="isWatermarkValueChange"></cdp-watermark-change-warning-chip>
                <button
                    *ngIf="job.hasUnsavedChanges"
                    [disabled]="job.isSaving"
                    hc-button
                    buttonStyle="link"
                    (click)="onCancel(job)"
                    title="{{ !job.form.value.ingestionId ? 'Remove this new job' : 'Undo changes to this job' }}"
                >
                    Cancel
                </button>
                <button
                    [disabled]="
                        job.form.disabled ||
                        !hasSourcesEditPermission ||
                        !job.form.valid ||
                        !job.hasUnsavedChanges ||
                        job.isSaving
                    "
                    hc-button
                    buttonStyle="primary-alt"
                    (click)="onSaveJobClicked(job)"
                >
                    Save
                </button>
            </div>
        </hc-accordion>
    </ng-container>
</form>

@if (hasSourcesEditPermission) {
    <span class="cdp-dotted-line-btn" (click)="createNewJob()">
        <span class="icon-left icon-add"></span>Add ingestion job
    </span>
}
